import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Textarea } from "../../themes/Default/components/Form/components/Textarea";
import { studentsManagement } from "../../hooks/api/StudentsManagement";
import { useTranslation } from "react-i18next";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../services/core/Select";
import { languageProgramsManagement } from "../../hooks/api/LanguageProgramsManagement";
import Divider from "../../themes/Default/components/Divider/Divider";
import { Title } from "../../themes/Default/components/Title";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { roles } from "../../services/utils/Roles";
import { useUserToken } from "../../hooks/core/UserToken";
import { toast } from "react-toastify";
import { Toaster } from "../../themes/Default/components/Toaster";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";

const ScoreTest = () => {
    const { t } = useTranslation("common");
    const { studentId, testId } = useParams();
    const formRef = useRef(null);
    const [languageProgram, setLanguageProgram] = useState([]);
    const [individualLessons, setIndividualLessons] = useState([]);
    const [test, setTest] = useState();

    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateTestMutation, useViewTestByProfessorMutation, useVerifyTestMutation, useCancelTestMutation } = studentsManagement;
    const [updateTest, { isLoading: isUpdatingTest }] = useUpdateTestMutation();
    const [viewTest] = useViewTestByProfessorMutation();
    const [verifyTest] = useVerifyTestMutation();
    const [cancelTest] = useCancelTestMutation();

    const { useProgramListMutation } = languageProgramsManagement;
    const [languageProgramList] = useProgramListMutation();

    const [status, setStatus] = useState([]);
    const { useStatusListMutation } = settingsCallManagement;
    const [statusList] = useStatusListMutation();

    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const tabs = [
        { title: t("details"), isActive: true },
    ];

    const gotoEditStudent = () => {
        navigate("/students/edit/" + studentId);
    };

    const gotoVerify = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        verifyTest({studentId, testId }).then((result) => {
                            if (result?.error) {
                                setFormErrors(result?.error?.data?.error?.violations);
                                toast.error(result.error.data.error.responseMessage);
                            } else {
                                toast.info(result?.data?.info?.responseMessage);
                                loadTest();
                            }
                        });
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    }

    const onCancel = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        cancelTest({studentId, testId }).then((result) => {
                            if (result?.error) {
                                toast.error(result.error.data.error.responseMessage);
                            } else {
                                toast.info(result.data.info.responseMessage);
                                loadTest();
                            }
                        });
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        updateTest({ body: values, studentId, testId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
            } else {
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    const individualLesson = () => {
        const options = [
            { id: "1", name: "1" },
            { id: "2", name: "2" },
            { id: "3", name: "3" },
            { id: "4", name: "4" },
            { id: "5", name: "5" },
            { id: "6", name: "6" },
            { id: "7", name: "7" },
            { id: "8", name: "8" },
            { id: "9", name: "9" },
            { id: "10", name: "10" },
            { id: "Ne", name: "Ne" }
        ];
    
        return prepareSelect(options);
    };

    const formatDateToDMY = (value) => {

        const parts = value.split("-");

        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    };

    const loadTest = () => {
        viewTest({ testId }).then((result) => {
            formRef.current.setValues(result?.data);
            setTest(result?.data);
            languageProgramList({language: result?.data?.language}).then((result) => {
                setLanguageProgram(prepareSelect(result?.data?.records));
            });
        });
    }

    useEffect(() => {
        loadTest();
        setIndividualLessons(individualLesson); 
        statusList().then((result) => {
            let options = [];
            result?.data?.records.map((status) => {
                options.push({
                    id: status.id,
                    name: status.status,
                });
            });
            setStatus(prepareSelect(options));
        });
    }, []);

    return (
        <DefaultLayout>
            <TopNavigation>
                <ButtonBack to={'/tests'} />
                {(
                    decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                    decodedToken?.roles.includes(roles.DIRECTOR) ||
                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                    decodedToken?.roles.includes(roles.SECRETARY) ||
                    (!test?.isVerified && 
                    (decodedToken?.roles.includes(roles.PROFESSOR) || decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR)) && 
                    !test?.isCanceled)
                ) && (
                    <Button title={t("save")} isDisabled={isUpdatingTest} icon="fa-regular fa-floppy-disk" onClick={onSave} />
                )}

                {(
                    (decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                    decodedToken?.roles.includes(roles.DIRECTOR) ||
                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)) &&
                    !test?.isCanceled
                ) && (
                    <Button title={t("verify")} icon="fa-regular fa-check" onClick={gotoVerify} isDisabled={!test?.canVerify} />
                )}

                {(
                    (decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                    decodedToken?.roles.includes(roles.DIRECTOR) ||
                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                    decodedToken?.roles.includes(roles.SECRETARY) ||
                    decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR)) &&
                    !test?.isCanceled && !test?.isVerified
                ) && (
                    <Button title={t("cancel")} icon="fa-regular fa-circle-xmark" onClick={onCancel} />
                )}

                {(
                    decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                    decodedToken?.roles.includes(roles.DIRECTOR) ||
                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                    decodedToken?.roles.includes(roles.SECRETARY)
                ) && (
                    <Button title={t("calls.viewStudent")} icon="fa-regular fa-eye" onClick={gotoEditStudent} />
                )}
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{t("students.tests")}</Title>
                <Breadcrumps>
                    <Link title={t("students.tests")} icon="fa-user-graduate"/>
                    <Link title={t("details")}  isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        backgroundKnowledge: "",
                        understanding: "",
                        expression: "",
                        vocabulary: "",
                        reading: "",
                        writtenTest: "",
                        individualLessons: "",
                        status: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                        <Row>
                            <Field>
                                <Input
                                    name="type"
                                    label={t("students.typeName")}
                                    value={values.type}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Input
                                    name="firstName"
                                    label={t("students.firstName")}
                                    value={values.firstName}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                            <Field>
                                <Input
                                    name="lastName"
                                    label={t("students.lastName")}
                                    value={values.lastName}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Input
                                    name="dateOfBirth"
                                    label={t("students.dateOfBirth")}
                                    value={values?.dateOfBirth ? formatDateToDMY(values?.dateOfBirth) : null}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                            <Field>
                                <Input
                                    name="grade"
                                    label={t("students.grade")}
                                    value={values.grade}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Input 
                                    name="professor" 
                                    label={t('groups.professor')} 
                                    value={values.professorName}
                                    onChange={handleChange} 
                                    disabled={true}
                                />
                            </Field>
                            <Field>
                                <Input
                                    name="location"
                                    label={t("groups.location")}
                                    value={values.locationName}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field>
                                <Input
                                    name="courseType"
                                    label={t("students.contractGroupType")}
                                    value={values.courseTypeName}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                            <Field>
                                <Input
                                    name="language"
                                    label={t("groups.language")}
                                    value={values.languageName}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea 
                                    name="backgroundKnowledge"
                                    label={t("test.backgroundKnowledge")}
                                    rows={5}
                                    value={values.backgroundKnowledge}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                            </Field>
                        </Row>
                        <Divider title={"Rezultati testa"} />
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="understanding"
                                    label={t("test.understanding")}
                                    rows={5}
                                    value={values.understanding}
                                    onChange={handleChange}
                                    error={formErrors?.understanding}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                            
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="expression"
                                    label={t("test.expression")}
                                    rows={5}
                                    value={values.expression}
                                    onChange={handleChange}
                                    error={formErrors?.expression}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="vocabulary"
                                    label={t("test.vocabulary")}
                                    rows={5}
                                    value={values.vocabulary}
                                    onChange={handleChange}
                                    error={formErrors?.vocabulary}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="reading"
                                    label={t("test.reading")}
                                    rows={5}
                                    value={values.reading}
                                    onChange={handleChange}
                                    error={formErrors?.reading}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                        </Row> 
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="writtenTest"
                                    label={t("test.writtenTest")}
                                    rows={5}
                                    value={values.writtenTest}
                                    onChange={handleChange}
                                    error={formErrors?.writtenTest}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                        </Row>
                        <Row>
                            <Field isFullWidth={true}>
                                <Textarea
                                    name="note"
                                    label={t("test.note")}
                                    rows={5}
                                    value={values.note}
                                    onChange={handleChange}
                                    error={formErrors?.note}
                                    disabled={!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified}
                                />
                            </Field>
                        </Row>
                        {(
                            decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                            decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                            decodedToken?.roles.includes(roles.SECRETARY) 
                        ) && (
                            <Row>
                                <Field>
                                    <Select
                                        name="status"
                                        label={t("status")}
                                        options={status}
                                        onChange={handleChange}
                                        selectedValue={values.status}
                                        error={formErrors?.status}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>                        
                        )}
                        <Row>
                            <Field>
                                <Select 
                                    name="individualLessons" 
                                    label={t('test.individualLesson')}
                                    onChange={handleChange} 
                                    options={individualLessons} 
                                    selectedValue={values.individualLessons}
                                    searchInDropdown={false}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                            <Field>
                                <Select 
                                    name="languageProgram" 
                                    label={t('test.languageProgram')} 
                                    onChange={handleChange} 
                                    options={languageProgram} 
                                    selectedValue={values.languageProgram} 
                                    error={formErrors?.program}
                                    searchInDropdown={false}
                                    disabled={(!decodedToken?.roles.includes(roles.SUPER_ADMIN) && !decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) && !decodedToken?.roles.includes(roles.SECRETARY) && test?.isVerified) || test?.isCanceled}
                                />
                            </Field>
                        </Row>
                    </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default ScoreTest;
